export const zIndices = {
  low: 10,
  mid: 20,
  high: 30,
}
